export default __webpack_public_path__ + "static/media/JSCircularBackground-light-sepia-200px.76eb2012.jpg";